export default {
	// 开始抽奖:
	luckDraw: {
		type: "get",
		url: "/consumer/mkt-activity/luckDraw"
	},

	// 添加收货信息:
	addExpressInformation: {
		type: "post",
		url: "/consumer/mkt-activity/addExpressInformationV2"
	},

	// 加入卡包：
	addCoupon: {
		type: "post",
		url:  "/consumer/mkt-activity/addCoupon"
	},

	// 查询中奖历史:
	findLucyRecord: {
		type: "get",
		url: "/consumer/mkt-activity/findLucyRecord"
	},

    // 检查是否可以填写地址:
    checkWriteAddress: {
        type: "get",
        url: "/consumer/mkt-activity/checkWriteAddress"
    },

	// 获取用户信息
	getInformationByParam: {
		type: "get",
		url: "/consumer/mkt-activity/getInformationByParam"
	},

	// 验证验证码:
	verification: {
		type: "get",
		url: "/consumer/user/verification"
	},

	// 获取验证码
	sendRandomNum: {
		type: "post",
		url: "/consumer/user/sendRandomNum"
	},

	// 开始抽奖2:
	newluckDraw: {
		type: "get",
		url: "/consumer/mkt-activity/newluckDraw"
	},

	// 查询中奖历史2:
	findLucyRecordByPhoneAndAct: {
		type: "get",
		url: "/consumer/mkt-activity/findLucyRecordByPhoneAndAct"
	},

	// 登录：
	login: {
		type: "post",
		url: "/consumer/user/login"
	},

  //获取cms配置的ICONLIST
	CmsGetTemplateByGroup:{
		type: 'post',
		url: '/cms/template/getTemplateByGroup'
	},
}


